import { z } from "zod";

/**
 * `GET /project-management/api/projects/{project_id}/daily-logs/search` 응답 계약.
 * 정본: docs/bricks-milestone-2/api-contract.md §3
 *
 * 기존 `Document` 타입(documents API)과는 별개다. 홈·기존 목록이 쓰는 타입을 덮어쓰지 않는다.
 */

const personSchema = z.object({
  id: z.number(),
  name: z.string(),
  avatar_url: z.string().nullable(),
});

const namedItemSchema = z.object({
  id: z.number(),
  name: z.string(),
});

const excerptSegmentSchema = z.object({
  text: z.string().min(1),
  matched: z.boolean(),
});

export const dailyLogSearchItemSchema = z.object({
  id: z.number(),
  date: z.string(),
  title: z.string(),
  writer: personSchema.nullable(),
  is_owner: z.boolean(),
  contractors: z.array(namedItemSchema),
  tags: z.array(namedItemSchema),
  excerpt: z.object({
    segments: z.array(excerptSegmentSchema),
    leading_ellipsis: z.boolean(),
    trailing_ellipsis: z.boolean(),
  }),
  locked: z.boolean(),
  modifier: personSchema.nullable(),
});

export const dailyLogSearchResponseSchema = z
  .object({
    results: z.array(dailyLogSearchItemSchema),
    count: z.number().int().nonnegative(),
    has_more: z.boolean(),
    next_cursor: z.string().min(1).nullable(),
  })
  .refine((page) => page.has_more === (page.next_cursor !== null), {
    message: "has_more and next_cursor must agree",
    path: ["next_cursor"],
  });

export type DailyLogSearchItem = z.infer<typeof dailyLogSearchItemSchema>;
export type DailyLogSearchExcerpt = DailyLogSearchItem["excerpt"];
export type DailyLogSearchResponse = z.infer<typeof dailyLogSearchResponseSchema>;

export const DAILY_LOG_SEARCH_ERROR_CODE = {
  INVALID_REQUEST_DATA: "INVALID_REQUEST_DATA",
  CURSOR_INVALID: "DAILY_LOG_SEARCH_CURSOR_INVALID",
  CURSOR_EXPIRED: "DAILY_LOG_SEARCH_CURSOR_EXPIRED",
  NOT_READY: "DAILY_LOG_SEARCH_NOT_READY",
} as const;
